import addComment from 'app/modules/comments/sagas/addComment';
import retrieveComments from 'app/modules/comments/sagas/retrieveComments';

const sagaRegistry = [addComment, retrieveComments];

export default sagaRegistry;
